export interface MenuItemConfig {
    id: string;             // data-id for the menu item
    i18nKey: string;       // I18n key
    defaultLabel: string;   // Default label if I18n key isn't found
    path?: string;          // Route path (undefined for actions like logout)
    sortOrder: number;      // Order in which items appear
    authority?: string;     // Authority required to see this item (if any)
    action?: string;        // Special action (e.g., 'logout')
    props?: Record<string, any>; // Additional props for the menu item
}

// Define all possible menu items with their sort order
export const accountMenuItems: MenuItemConfig[] = [
    {
        id: 'accountDetailsBtn',
        i18nKey: 'accountDetails',
        defaultLabel: 'My Account',
        path: '/account-details',
        sortOrder: 100,
    },
    {
        id: 'accountBalanceBtn',
        i18nKey: 'myAccountBlance', // Note: there's a typo in your original code
        defaultLabel: 'My Account Balance',
        path: '/account-details/account-balance',
        sortOrder: 200,
        authority: 'CAN_VIEW_ACCOUNT_BALANCE'
    },
    {
        id: 'myPreferencesBtn',
        i18nKey: 'myPreferences',
        defaultLabel: 'My Preferences',
        path: '/preferences',
        sortOrder: 300
    },
    {
        id: 'logoutBtn',
        i18nKey: 'logout',
        defaultLabel: 'Logout',
        sortOrder: 400, // Higher number to ensure it appears at the bottom
        action: 'logout'
    }
];
